import { Checkbox } from "@components";
import style from "@styles/pages/oraculo/oraculo.module.scss";

import { Numbers } from "@utils/Numbers";
import classNames from "classnames/bind";
const css = classNames.bind(style);

export const Tag = ({
  id,
  name,
  description = "",
  icon = null,
  quantity = 0,
  percentage = 0,
  onSelectFilters,
  filters,
}) => {
  const isUndefined = parseInt(id) == "0";

  return (
    <div
      className={css({
        item: true,
        selected: filters.includes(id),
      })}
      onClick={() => onSelectFilters(id)}
    >
      <div className="d-flex flex-column">
        <p className={style.name}>{name}</p>
        <div className="d-flex align-center">
          {!isUndefined && (
            <span className={style.percentage}>{percentage}</span>
          )}
          {isUndefined ? (
            <span className={style.quantity}>
              {Numbers.formatInt(quantity)}
            </span>
          ) : (
            <span className={style.quantity}>
              <span className={style.dot} /> {Numbers.formatInt(quantity)}
            </span>
          )}
        </div>
      </div>

      {description && <p className={style.temperature}>{description}</p>}
      <div className={style.iconContainer}>
        <div className={style.icon}>
          {icon && <i className={icon} />}
          <div className={style.checkbox}>
            <Checkbox value={id} checked={filters.includes(id)} />
          </div>
        </div>
      </div>
    </div>
  );
};
